import DashView from './components/Dash.vue'
import LoginView from './components/Login.vue'
// import UserLoginView from './components/UserLogin.vue'
import LogoutView from './components/Logout.vue'
import UserLogoutView from './components/UserLogout.vue'
import NotFoundView from './components/404.vue'
import UserRegisterFillInfoView from './components/UserRegisterFillInfo.vue'
import UserRegisterCompleteView from './components/UserRegisterComplete.vue'
// Import Views - Dash
import ListUserView from './components/views/ListUser.vue'
import AddUserView from './components/views/AddUser.vue'
import EditUserView from './components/views/EditUser.vue'
import ListMessageView from './components/views/ListMessage.vue'
import AddMessageView from './components/views/AddMessage.vue'
import EditMessageView from './components/views/EditMessage.vue'
import ListAppView from './components/views/ListApp.vue'
import AddAppView from './components/views/AddApp.vue'
import EditAppView from './components/views/EditApp.vue'
import ListFileView from './components/views/ListFile.vue'
import ListSampleView from './components/views/ListSample.vue'
import ListMotionFileView from './components/views/ListMotionFile.vue'
import ListMotionFileForAdminView from './components/views/ListMotionFileForAdmin.vue'
import EditMotionFileForAdminView from './components/views/EditMotionFileForAdmin.vue'
import AddMotionFileForAdminView from './components/views/AddMotionFileForAdmin.vue'
import ListCategoryView from './components/views/ListCategory.vue'
import AddCategoryView from './components/views/AddCategory.vue'
import EditCategoryView from './components/views/EditCategory.vue'
import ListTagView from './components/views/ListTag.vue'
import AddTagView from './components/views/AddTag.vue'
import EditTagView from './components/views/EditTag.vue'
import SdkDescriptionView from './components/views/sdkDescription.vue'
import ListApp2View from './components/views/ListApp2.vue'
import NewIndexView from './components/NewIndex.vue'
// [fu]listMotionFile
import Build from './components/views/Build.vue'
import Introduces from './components/Introduces.vue'
// Routes
const routes = [
    {
        path: '/developerAdmin/login',
        component: LoginView,
        name: 'login'
    },
    {
        path: '/developerAdmin',
        component: DashView,
        children: [
            {
                path: 'listUser',
                component: ListUserView,
                name: 'listUser',
                meta: {description: 'User list Page', requiresAuth: true, requireAdmin: true}
            }, {
                path: 'addUser',
                component: AddUserView,
                name: 'addUser',
                meta: {description: 'Add user page', requiresAuth: true, requireAdmin: true}
            }, {
                path: 'user/:userId/edit',
                component: EditUserView,
                name: 'editUser',
                meta: {description: 'Edit user page', requiresAuth: true, requireAdmin: true}
            }, {
                path: 'logout',
                component: LogoutView,
                name: 'logout'
            }, {
                path: 'listMessage',
                component: ListMessageView,
                name: 'listMessage',
                meta: {description: 'Message list Page', requiresAuth: true, requireAdmin: true}
            }, {
                path: 'addMessage',
                component: AddMessageView,
                name: 'addMessage',
                meta: {description: 'Add message page', requiresAuth: true, requireAdmin: true}
            }, {
                path: 'message/:messageId/edit',
                component: EditMessageView,
                name: 'editMessage',
                meta: {description: 'Edit message page', requiresAuth: true, requireAdmin: true}
            }, {
                path: 'listMotionFileForAdmin',
                component: ListMotionFileForAdminView,
                name: 'listMotionFileForAdmin',
                meta: {description: 'Motion file list page', requiresAuth: true, requireAdmin: true}
            }, {
                path: 'addMotionFileForAdmin',
                component: AddMotionFileForAdminView,
                name: 'addMotionFileForAdmin',
                meta: {description: 'Add motion file page', requiresAuth: true, requireAdmin: true}
            }, {
                path: 'motionFile/:motionFileId/edit',
                component: EditMotionFileForAdminView,
                name: 'editMotionFileForAdmin',
                meta: {description: 'Edit motion file page', requiresAuth: true, requireAdmin: true}
            }, {
                path: 'listCategory',
                component: ListCategoryView,
                name: 'listCategory',
                meta: {description: 'Category list page', requiresAuth: true, requireAdmin: true}
            }, {
                path: 'addCategory',
                component: AddCategoryView,
                name: 'addCategory',
                meta: {description: 'Add category page', requiresAuth: true, requireAdmin: true}
            }, {
                path: 'category/:motionCategoryId/edit',
                component: EditCategoryView,
                name: 'editCategory',
                meta: {description: 'Edit category page', requiresAuth: true, requireAdmin: true}
            }, {
                path: 'listTag',
                component: ListTagView,
                name: 'listTag',
                meta: {description: 'Tag list page', requiresAuth: true, requireAdmin: true}
            }, {
                path: 'addTag',
                component: AddTagView,
                name: 'addTag',
                meta: {description: 'Add tag page', requiresAuth: true, requireAdmin: true}
            }, {
                path: 'tag/:motionTagId/edit',
                component: EditTagView,
                name: 'editTag',
                meta: {description: 'Edit tag page', requiresAuth: true, requireAdmin: true}
            }
        ]
    },
    {
        path: '/documents',
        component: DashView,
        children: [
            {
                path: 'build',
                component: Build,
                name: 'build'
            },
            {
                path: 'listAppOld',
                component: ListAppView,
                name: 'listAppOld',
                meta: {description: 'App list Page', requiresAuth: true}
            }, {
                path: 'addApp',
                component: AddAppView,
                name: 'addApp',
                meta: {description: 'Add app page', requiresAuth: true}
            }, {
                path: 'app/:appId/edit',
                component: EditAppView,
                name: 'editApp',
                meta: {description: 'Edit app page', requiresAuth: true}
            }, {
                path: 'listFile',
                component: ListFileView,
                name: 'listFile',
                meta: {description: 'File list page', requiresAuth: true}
            }, {
                path: 'listSample',
                component: ListSampleView,
                name: 'listSample',
                meta: {description: 'Sample list page', requiresAuth: true}
            }, {
                path: 'userLogout',
                component: UserLogoutView,
                name: 'userLogout'
            }, {
                path: 'intro',
                component: ListApp2View,
                name: 'listApp',
                meta: {description: 'App list Page', requiresAuth: true}
            }, {
                path: 'listMotionFile',
                component: ListMotionFileView,
                name: 'listMotionFile',
                meta: {description: 'Motion file list page', requiresAuth: true}
            }, {
                path: 'sdkDescription/:sdkName',
                component: SdkDescriptionView,
                name: 'sdkDescription',
                meta: {description: 'SDK Description Page', requiresAuth: true}
            }
        ]
    },
// Homepage/Distribute介紹商城&方案Loading layers…
    {
        path: '/programs',
        component: Introduces,
        name: 'introduces'
    },
// Account/登入/填寫狀態&填寫正常
    // {
    //     path: '/developerUser/login',
    //     component: UserLoginView,
    //     name: 'userLogin'
    // },
    {
        path: '/user/register/fill/info',
        component: UserRegisterFillInfoView,
        name: 'userRegisterFillInfo'
    },
    {
        path: '/user/register/complete',
        component: UserRegisterCompleteView,
        name: 'userRegisterComplete'
    },
    {
        path: '/',
        component: NewIndexView,
        name: 'newIndex'
    },
    {
        // not found handler
        path: '*',
        component: NotFoundView
    }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js